module.exports = __webpack_public_path__ + "img/122.f717999e.jpg";